var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.annotation[_vm.type])}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }